import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const userName = 'User-Name'
const userID = 'USER-ID'
const theme = 'USER-Theme'
export function getToken() {
    return Cookies.get(TokenKey)
}
export function getuserName() {
    return Cookies.get(userName)
}
export function getuserID() {
    return Cookies.get(userID)
}
export function setToken(token) {
    return Cookies.set(TokenKey, token)
}
export function setuserName(token) {
    return Cookies.set(userName, token)
}
export function setuserID(token) {
    return Cookies.set(userID, token)
}
export function removeToken() {
    return Cookies.remove(TokenKey)
}
export function setTheme(color) {
    return Cookies.set(theme, color)
}
export function getTheme() {
    return Cookies.get(theme)
}


// WEBPACK FOOTER //
// ./src/util/auth.js